<div class="entity_search">
  <input
    id="textInput"
    [disabled]="disableInternal"
    [editable]="false"
    [inputFormatter]="formatter"
    [ngbTypeahead]="searchEntityBinding"
    [placeholder]="placeholderText"
    [resultTemplate]="rt"
    [(ngModel)]="searchTerm"
    (selectItem)="onSelectItem($event)"
    (typeahead-min-length)="(3)" />
</div>

<i
  *ngIf="selectedEntity"
  class="lx-icon lx-close-x"
  (click)="clear()"></i>

<div
  *ngIf="searchFailed"
  class="error dropdownMenu">
  {{ errorMessage }}
</div>

<ng-template
  #rt
  let-r="result"
  let-t="term">
  <img
    class="result-img"
    [src]="getIcon(r.entityType)" />
  <ngb-highlight
    [result]="r | entityPath"
    [term]="t"></ngb-highlight>
</ng-template>
